import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import getConfig from '../../config';
import { ViewOwnProps } from '../../definitions/types';

import './productChoiceView.scss';

type IProductViewProps = ViewOwnProps & WithTranslation;

export class ProductChoiceView extends React.Component<IProductViewProps, {}> {
  public render(): JSX.Element {
    // Always redirect to new product picker
    // (previously controlled by 'new-product-picker-redirect' LD flag, now permanently enabled)
    window.location.assign(getConfig().dashEndpoint + '/product-picker');

    return null;
  }
}

export default withTranslation()(ProductChoiceView);
